import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
  selector: '[evkMatTitle]'
})
export class MatTitleDirective {

    @HostBinding('class')
    public class = 'mat-title';

}
